import React from 'react';

function AccountIcon() {
  return (
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>Manage Account</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <path d="M16,32 C24.837,32 32,24.837 32,16 C32,7.163 24.837,0 16,0 C7.163,0 0,7.163 0,16 C0,24.837 7.163,32 16,32" fill="#404040"></path>
        <path d="M26.952,25.8421 C26.302,22.2351 23.905,19.9731 20.689,18.9041 C19.369,19.8641 17.758,20.4481 16,20.4481 C14.242,20.4481 12.631,19.8641 11.311,18.9041 C8.095,19.9731 5.699,22.2351 5.048,25.8421 C7.819,28.7101 11.698,30.5001 16,30.5001 C20.303,30.5001 24.181,28.7101 26.952,25.8421" fill="#FEFEFE"></path>
        <path d="M16,19.0603 C19.652,19.0603 22.612,16.1003 22.612,12.4483 C22.612,8.7963 19.652,5.8363 16,5.8363 C12.348,5.8363 9.388,8.7963 9.388,12.4483 C9.388,16.1003 12.348,19.0603 16,19.0603" fill="#FEFEFE"></path>
      </g>
    </svg>
  );
}

export default AccountIcon;



// WEBPACK FOOTER //
// ./src/components/icons/AccountIcon.js